import { render, staticRenderFns } from "./CardPreview.vue?vue&type=template&id=54062cdc"
import script from "./CardPreview.vue?vue&type=script&lang=js"
export * from "./CardPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54062cdc')) {
      api.createRecord('54062cdc', component.options)
    } else {
      api.reload('54062cdc', component.options)
    }
    module.hot.accept("./CardPreview.vue?vue&type=template&id=54062cdc", function () {
      api.rerender('54062cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChartForm/CardPreview.vue"
export default component.exports